import { React, useRef, useState, useEffect } from "react";

import ValidationText from "../../../utils/validation/ValidationText";

import { APIURL, GetImage } from "../../../services/axiosServices/ApiEndPoints";
import moment from "moment";
import TextInput from "../../../components/UIComponent/TextInput";
import DateInput from "../../../components/inputs/DateInput";
import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";

function ProjectInfoSummary(props) {
  const TIER_NAMES = {
    1: "A Star",
    2: "A",
    3: "B",
    4: "C"
  };
  return (
    <>
      <div className="container mx-auto">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12">
            <div className=" bg-gray-box  ">
              <div className="form-info-title">
                <h4 className="text-[#2d2d2d] form-info-title-txt">
                  Project(s) to Cite in Written Report
                </h4>
                <p className="mt-2 mb-2">
                  Your report (in Part 7) should refer to projects you have
                  cited here. List the project experiences which you will be
                  citing in your report to show your roles, responsibilities,
                  and involvement in the project(s). Please attach documentary
                  proof of the project(s) contract value, where possible.
                </p>
                <ul className="list-disc pl-4">
                  <li>
                    Accredited Construction Professional (A-Star) – At least one
                    construction project with a minimum size of $150m in the
                    capacity of Project Manager or above.
                  </li>
                  <li>
                    Accredited Construction Professional (A) – At least one
                    construction project with a minimum size of $85m in the
                    capacity of Project Manager or above.
                  </li>
                  <li>
                    Accredited Construction Professional (B) – At least one
                    construction project with a minimum size of $25m in the
                    capacity of Deputy Project Manager or above.
                  </li>
                  <li>
                    Accredited Construction Professional (C) – One or more
                    construction projects with a combined total size of at least
                    $10m.
                  </li>
                </ul>
              </div>
              <div className="col-span-12 ">
                <div className="mb-2"></div>
                <div className="table-section">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-[#005b9c] text-white">
                        <tr>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Project Title
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Project Value
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Role
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Project Duration
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Date From
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Date To
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            First Name
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Last Name
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Role
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Email Address
                          </th>
                          <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm custom-tbody">
                        {props.projectInformation.projectCitedInReport?.map(
                          (citeReport, key) => (
                            <tr
                              className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]"
                              key={key}
                            >
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.projectTitle}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.projectValue}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.roleInProject}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.projectDuration}
                              </td>

                              <td className="text-left py-2 px-5">
                                {citeReport.projectDateFrom
                                  ? moment(citeReport.projectDateFrom).format('DD MMM YYYY')
                                  : ''}
                              </td>

                              <td className="text-left py-2 px-5">
                                {citeReport.projectDateTo
                                  ? moment(citeReport.projectDateTo).format('DD MMM YYYY')
                                  : ''}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.endorserFirstName}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.endorserLastName}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.endorserRole}
                              </td>
                              <td className="text-left py-2 lg:px-5 px-2">
                                {citeReport.endorserEmail}
                              </td>

                              <td className="py-2 px-5 text-center">
                                <div className="flex gap-2">
                                  <button
                                    className="action-btn flex gap-2"
                                    onClick={() => {
                                      props.getProjectCitedInReport(key);
                                      props.setOpenProjectCitedInReportModal(
                                        true
                                      );
                                    }}
                                  >
                                    <img
                                      className="min-h-[30px] min-w-[30px] mx-auto"
                                      src="../edit.png"
                                      alt=""
                                    />
                                  </button>
                                  <button
                                    className="action-btn flex gap-2"
                                    onClick={() =>
                                      props.deleteCpasProjectCitedInReport(
                                        citeReport.projectCitedInReportId
                                      )
                                    }
                                  >
                                    <img
                                      className="min-h-[30px] min-w-[30px] mx-auto"
                                      src="../delete-icon.svg"
                                      alt=""
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-12 md:gap-10 md:gap-4 gap-3 w-full justify-between mt-5 mb-8">
                <div className="col-span-12">
                  <div className="flex justify-end">
                    <button
                      className="btn btn-border-caps"
                      onClick={() =>
                        props.setOpenProjectCitedInReportModal(true)
                      }
                    >
                      <span className="fa fa-plus"></span>
                      <span className="ml-2">Add</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="form-info-title">
                <h4 className="text-[#2d2d2d] form-info-title-txt">
                  Written Report and Supporting Documents
                </h4>
                <p>
                  Please upload your written report and supporting documents (eg. latest CV, organisation chart, PQP, master programme etc.) in one ZIP folder.
                </p>
                <h2 className="input-title mb-3">
                  Report (Accredited Construction Professional {TIER_NAMES[props.basicApplicationDetails.applicationTierId] || ""})
                  <span className="text-[#C00000]"> *</span>
                  <span className='input mr-5 text-[#808080]'>  (ZIP and RAR files only)</span>
                  <button
                    className="underline text-[#005b9c] font-[500] pl-4"
                    onClick={(e) => {
                      e.preventDefault();
                      props.GetCPASMemberFiles(
                        "Templates",
                        "revised application form.zip"
                      );
                    }}
                  >
                    Download template
                  </button>
                </h2>

                <div className="dropdown">
                  <div className="select-dropdown w-full">
                    {props && props.isACRACerLoader ? (
                      <ButtonLoader type="btn btn-caps" />
                    ) : (
                      <>
                        <div className='eduinfo-uplaod-button flex'>
                          <form className="custom-uploader custom-file-upload-btn flex">
                            <div className="border border-[#f3f3f3] btn btn-caps cursor-pointer">
                              <label
                                htmlFor="Upload_Accrediate_Construction_Professional_Report"
                                className="text-uplod text-white cursor-pointer"
                              >
                                Upload File
                              </label>
                              <input
                                className="sr-only"
                                id="Upload_Accrediate_Construction_Professional_Report"
                                type="file"
                                accept=".zip,.rar,application/zip,application/x-rar-compressed"
                                onChange={(event) =>
                                  props.onFileChange(
                                    event,
                                    "Upload_Accrediate_Construction_Professional_Report"
                                  )
                                }
                              />
                            </div>
                          </form>
                          {props.projectAndPaymentInfoSummary?.accreditedConProReportPath && (
                            <div className="w-auto">
                              <button
                                type="button"
                                className="ml-5 2xl:px-7 lg:px-5 py-2 btn btn-skyblue-border text-xl border text-[#4687C6]"
                                onClick={() =>
                                  props.GetCPASMemberFiles(
                                    "Upload_Accrediate_Construction_Professional_Report",
                                    props.projectAndPaymentInfoSummary
                                      .accreditedConProReportPath
                                  )
                                }
                              >
                                <span className="text-xl text-[#4687C6] font-semibold tracking-normal underline">
                                  View Files
                                </span>
                              </button>
                            </div>

                          )}
                        </div>
                      </>

                    )}

                    {props?.projectAndPaymentInfoSummary
                      ?.accreditedConProReportPath && (
                        <div className="mt-5 file-uploaded-txt flex items-center">
                          <img
                            src="/check-caps.png"
                            className="w-[25px] mr-3"
                            alt=""
                          />
                          <span className="text-[#000]">
                            {
                              props.projectAndPaymentInfoSummary
                                .accreditedConProReportPath
                            }
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap justify-end mt-16">
                {props && props.isSubmitLoader ? (
                  <ButtonLoader type="btn btn-caps" />
                ) : (
                  <button
                    className="btn btn-caps"
                    onClick={() =>
                      props.submitProjectSummaryInformation("isSave")
                    }
                  >
                    <span className="">Save</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.openProjectCitedInReportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white w-[95%] max-w-6xl rounded-lg shadow-lg p-6 relative max-h-[90vh] overflow-y-auto">
            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-semibold">
                Your report should be referenced to projects you managed or were
                involved in. List the project experiences which you will be
                citing in your report to show your roles, responsibilities and
                involvement in the project(s). Please attach documentary proof
                of the project(s) contract value, where possible.
              </h3>
              <button
                className="text-xl"
                onClick={() => props.setOpenProjectCitedInReportModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-12 gap-4">
              {/* Project Details */}
              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Project Title <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="projectTitle"
                  value={props.projectInformationdetail.projectTitle}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //  onBlur={() => props.validateField("projectTitle", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Project Value <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="projectValue"
                  value={props.projectInformationdetail.projectValue}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //  onBlur={() => props.validateField("projectValue", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Role In Project <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="roleInProject"
                  value={props.projectInformationdetail.roleInProject}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("roleInProject", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Project Duration <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="projectDuration"
                  value={props.projectInformationdetail.projectDuration}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("projectDuration", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Date From <span className="text-[#C00000]"> *</span>
                </h2>
                <DateInput
                  name="projectDateFrom"
                  value={moment(
                    props.projectInformationdetail.projectDateFrom
                  ).format("YYYY-MM-DD")}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("projectDateFrom", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  Date To <span className="text-[#C00000]"> *</span>
                </h2>
                <DateInput
                  name="projectDateTo"
                  value={moment(
                    props.projectInformationdetail.projectDateTo
                  ).format("YYYY-MM-DD")}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("projectDateTo", "Project_Cite_Report")}
                />
              </div>

              <div className="col-span-12">
                <h2 className="input-title mb-2">
                  Description of Type and Scope{" "}
                  <span className="text-[#C00000]"> *</span>
                </h2>
                <textarea
                  rows="3"
                  name="projectTypeAndScope"
                  className="w-full"
                  value={props.projectInformationdetail.projectTypeAndScope}
                  onChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //onBlur={() => props.validateField("projectTypeAndScope", "Project_Cite_Report")}
                />
              </div>

              <div className="col-span-12">
                <h2 className="input-title mb-2">
                  Description of your Role in the Project{" "}
                  <span className="text-[#C00000]"> *</span>
                </h2>
                <textarea
                  rows="3"
                  name="roleDescription"
                  className="w-full"
                  value={props.projectInformationdetail.roleDescription}
                  onChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //  onBlur={() => props.validateField("roleDescription", "Project_Cite_Report")}
                />
              </div>

              <div className="col-span-12">
                <h2 className="input-title mb-2">
                  Description of your Responsiblities in the Various Stages of
                  the Project (Planning / Construction / Completion){" "}
                  <span className="text-[#C00000]"> *</span>
                </h2>
                <textarea
                  rows="4"
                  name="responsibilitiesDescription"
                  className="w-full"
                  value={
                    props.projectInformationdetail.responsibilitiesDescription
                  }
                  onChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //onBlur={() => props.validateField("responsibilitiesDescription", "Project_Cite_Report")}
                />
              </div>

              {/* Document Upload */}
              <div className="lg:col-span-12 col-span-12">
                <h2 className="input-title mb-3">
                  Upload Documentary Proof of the Project
                  <span className="text-[#C00000]">*</span>
                  <span className='input mr-5 text-[#808080]'> (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)</span>
                </h2>
                <div className="flex item-center flex-col">
                  {props && props.isUploadDocumentary ? (
                    <ButtonLoader type="btn btn-conquas" />
                  ) : (
                    <>
                      <div className="eduinfo-uplaod-button flex">
                        <form className="custom-uploader custom-file-upload-btn flex">
                          <div className="border border-[#f3f3f3] btn  btn-caps cursor-pointer">
                            <label
                              htmlFor={`Documentary_Proof_Project`}
                              className="text-uplod text-white cursor-pointer"
                            >
                              Upload File
                            </label>
                            <input
                              className="sr-only"
                              id={`Documentary_Proof_Project`}
                              type="file"
                              onChange={(event) =>
                                props.onFileChange(
                                  event,
                                  "Documentary_Proof_Project"
                                )
                              }
                            />
                          </div>
                        </form>
                        {props.projectInformationdetail
                          .projectDocumentFilePath ? (
                          <button
                            className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                            style={{ borderColor: "#005b9c" }}
                            onClick={(event) =>
                              props.GetCPASMemberFiles(
                                "Documentary_Proof_Project",
                                props.projectInformationdetail
                                  .projectDocumentFilePath
                              )
                            }
                          >
                            View File
                          </button>
                        ) : null}
                      </div>
                    </>
                  )}
                  {props &&
                    props.projectInformationdetail.projectDocumentFilePath ? (
                    <div className="mt-5 file-uploaded-txt flex items-center">
                      <span className="text-[#000]">
                        {props.projectInformationdetail.projectDocumentFilePath}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-span-12 text-sm mt-2">
                Endorsement by Technical Controller, Project QP / PE or
                equivalent.
              </div>
              {/* Endorser Info */}
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  {" "}
                  First Name <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="endorserFirstName"
                  value={props.projectInformationdetail.endorserFirstName}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                //  onBlur={() => props.validateField("endorserFirstName", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  {" "}
                  Last Name <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="endorserLastName"
                  value={props.projectInformationdetail.endorserLastName}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("endorserLastName", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  {" "}
                  Role <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="endorserRole"
                  value={props.projectInformationdetail.endorserRole}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("endorserRole", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-6 col-span-12 input-sec-texts">
                <h2 className="input-title mb-2">
                  {" "}
                  Email Address <span className="text-[#C00000]"> *</span>
                </h2>
                <TextInput
                  name="endorserEmail"
                  value={props.projectInformationdetail.endorserEmail}
                  handleChange={(e) =>
                    props.handleChange(e, "Project_Cited_In_Report")
                  }
                // onBlur={() => props.validateField("endorserEmail", "Project_Cite_Report")}
                />
              </div>

              <div className="lg:col-span-12 col-span-12 input-sec-texts">
                <h2 className="input-title mb-3">
                  Upload Endorsement <span className="text-[#C00000]">*</span>
                  <span className='input mr-5 text-[#808080]'> (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)</span>
                  <button
                    className="underline text-[#005b9c] font-[500] pl-4"
                    onClick={(e) => {
                      e.preventDefault();
                      props.GetCPASMemberFiles(
                        "Templates",
                        "Annex 2 - Endorsement by Technical Controller Upload - CRM CPAS 1.pdf"
                      );
                    }}
                  >
                    Download template
                  </button>
                </h2>
                <div className="flex item-center flex-col">
                  {props && props.isEndorsement ? (
                    <ButtonLoader type="btn btn-conquas" />
                  ) : (
                    <>
                      <div className="eduinfo-uplaod-button flex">
                        <form className="custom-uploader custom-file-upload-btn flex">
                          <div className="border border-[#f3f3f3] btn  btn-caps cursor-pointer">
                            <label
                              htmlFor={`Endorsement_Project`}
                              className="text-uplod text-white cursor-pointer"
                            >
                              Upload File
                            </label>
                            <input
                              className="sr-only"
                              id={`Endorsement_Project`}
                              type="file"
                              onChange={(event) =>
                                props.onFileChange(event, "Endorsement_Project")
                              }
                            />
                          </div>
                        </form>
                        {props.projectInformationdetail.endorsementFilePath ? (
                          <button
                            className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                            style={{ borderColor: "#005b9c" }}
                            onClick={(event) =>
                              props.GetCPASMemberFiles(
                                "Endorsement_Project",
                                props.projectInformationdetail
                                  .endorsementFilePath
                              )
                            }
                          >
                            View File
                          </button>
                        ) : null}
                      </div>
                    </>
                  )}
                  {props &&
                    props.projectInformationdetail.endorsementFilePath ? (
                    <div className="mt-5 file-uploaded-txt flex items-center">
                      <span className="text-[#000]">
                        {props.projectInformationdetail.endorsementFilePath}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {/* FOOTER */}
            <div className="flex justify-end gap-4 mt-8">
              <button
                className="btn btn-border-caps"
                onClick={() => props.setOpenProjectCitedInReportModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-caps"
                onClick={() => {
                  props.handleAddRemoveDataList(
                    "HandleAdd",
                    "ProjectCitedInReport"
                  );
                  // setOpenProjectCitedInReportModal(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default ProjectInfoSummary;
